var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClickHere(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 840,
    height: 301,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6f7f7",
      stroke: "none"
    },
    d: "M0 0L0 301L840 301L840 0L0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M688 41L688 42L691 42L688 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2ea",
      stroke: "none"
    },
    d: "M691 41L691 42L694 42L691 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M694 41L694 42L708 42L694 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2ea",
      stroke: "none"
    },
    d: "M708 41L709 42L708 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M709 41L709 42L712 42L709 41M680.667 42.3333L681.333 42.6667L680.667 42.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2ea",
      stroke: "none"
    },
    d: "M682 42L683 43L682 42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M683.667 42.3333L684.333 42.6667L683.667 42.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#025a7f",
      stroke: "none"
    },
    d: "M685 42.4283C668.927 44.7297 653.809 50.2521 640 58.814C627.942 66.2903 617.037 76.2822 609.029 88C565.691 151.409 599.845 238.668 674 257.255C687.595 260.662 702.197 260.853 716 258.869C731.26 256.675 746.077 251.061 759 242.655C815.609 205.833 826.205 121.051 776.911 73.1698C762.344 59.0202 744.613 49.5009 725 44.6266C712.421 41.5004 697.886 40.583 685 42.4283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M714.667 42.3333L715.333 42.6667L714.667 42.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2ea",
      stroke: "none"
    },
    d: "M716 42L717 43L716 42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M717.667 42.3333L718.333 42.6667L717.667 42.3333M675.667 43.3333L676.333 43.6667L675.667 43.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M677.667 43.3333L678.333 43.6667L677.667 43.3333M720 43L721 44L720 43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2ea",
      stroke: "none"
    },
    d: "M721 43L722 44L721 43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M722 43L723 44L722 43M671 44L672 45L671 44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2ea",
      stroke: "none"
    },
    d: "M672 44L673 45L672 44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M673 44L674 45L673 44M724.667 44.3333L725.333 44.6667L724.667 44.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M726.667 44.3333L727.333 44.6667L726.667 44.3333M667.667 45.3333L668.333 45.6667L667.667 45.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M669 45L670 46L669 45M728.667 45.3333L729.333 45.6667L728.667 45.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M730 45L731 46L730 45M664 46L665 47L664 46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2ea",
      stroke: "none"
    },
    d: "M665 46L666 47L665 46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M666 46L667 47L666 46M732 46L733 47L732 46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M733 46L734 47L733 46M661.667 47.3333L662.333 47.6667L661.667 47.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M663 47L664 48L663 47M735 47L736 48L735 47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M736 47L737 48L736 47M659 48L660 49L659 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M660 48L661 49L660 48M738 48L739 49L738 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M739 48L740 49L739 48M656 49L657 50L656 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2ea",
      stroke: "none"
    },
    d: "M657 49L658 50L657 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M658 49L659 50L658 49M740 49L741 50L740 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2ea",
      stroke: "none"
    },
    d: "M741 49L742 50L741 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M742 49L743 50L742 49M654 50L655 51L654 50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M655 50L656 51L655 50M743 50L744 51L743 50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M744 50L745 51L744 50M652 51L653 52L652 51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M653 51L654 52L653 51M745 51L746 52L745 51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M746 51L747 52L746 51M650 52L651 53L650 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M651 52L652 53L651 52M747 52L748 53L747 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M748 52L749 53L748 52M648 53L649 54L648 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M649 53L650 54L649 53M749 53L750 54L749 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M750 53L751 54L750 53M646 54L647 55L646 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M647 54L648 55L647 54M751 54L752 55L751 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M752 54L753 55L752 54M644 55L645 56L644 55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M645 55L646 56L645 55M753 55L754 56L753 55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M754 55L755 56L754 55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2ea",
      stroke: "none"
    },
    d: "M643 56L644 57L643 56M755 56L756 57L755 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M641 57L642 58L641 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M642 57L643 58L642 57M756 57L757 58L756 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M757 57L758 58L757 57M639 58L640 59L639 58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M640 58L641 59L640 58M758 58L760 60L758 58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M759 58L760 59L759 58M638 59L639 60L638 59M760 59L761 60L760 59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M637 60L638 61L637 60M761 60L762 61L761 60z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M635 61L636 62L635 61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M762 61L763 62L762 61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M763 61L764 62L763 61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M634 62L635 63L634 62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2ea",
      stroke: "none"
    },
    d: "M764 62L765 63L764 62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M632 63L633 64L632 63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M633 63L634 64L633 63M765 63L767 65L765 63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M766 63L767 64L766 63M631 64L632 65L631 64M767 64L768 65L767 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2ea",
      stroke: "none"
    },
    d: "M630 65L631 66L630 65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M768 65L769 66L768 65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M629 66L630 67L629 66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2ea",
      stroke: "none"
    },
    d: "M769 66L770 67L769 66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M628 67L629 68L628 67M770 67L771 68L770 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M626 68L627 69L626 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M627 68L628 69L627 68M771 68L774 71L771 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M772 68L773 69L772 68M625 69L626 70L625 69M773 69L774 70L773 69M624 70L625 71L624 70M774 70L775 71L774 70M623 71L624 72L623 71M775 71L776 72L775 71M87 72L87 73L93 73L87 72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2ea",
      stroke: "none"
    },
    d: "M612 230C604.497 218.364 595.733 208.034 590.453 195C578.544 165.603 579.1 131.847 592.309 103C597.525 91.6068 605.161 82.3493 612 72L260 72L148 72C127.349 72 105.365 69.8516 85 73.615C36.2222 82.6291 21.4911 139.743 34.0363 182C52.4425 244 128.335 230 178 230L612 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M623 230C615.175 218.889 605.577 209.679 599.865 197C582.481 158.411 586.922 100.592 623 73C606.914 66.25 595.25 94.5323 590.604 106C578.112 136.838 578.798 173.09 593.753 203C600.43 216.354 606.903 230 623 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M776 72L777 73L776 72M82 73L82 74L86 74L82 73M777 73L778 74L777 73M79.6667 74.3333L80.3333 74.6667L79.6667 74.3333M778 74L779 75L778 74M76.6667 75.3333L77.3333 75.6667L76.6667 75.3333M779 75L780 76L779 75M73.6667 76.3333L74.3333 76.6667L73.6667 76.3333M71 77L72 78L71 77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M780 77L781 78L780 77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M69 78L70 79L69 78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M781 78L782 79L781 78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M67 79L68 80L67 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M782 79L783 80L782 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M65 80L66 81L65 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M783 80L784 81L783 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M63.6667 81.3333L64.3333 81.6667L63.6667 81.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2ea",
      stroke: "none"
    },
    d: "M784 81L785 82L784 81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M61.6667 82.3333L62.3333 82.6667L61.6667 82.3333M785 82L787 84L785 82M60 83L61 84L60 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M785 83L786 84L785 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M59 84L60 85L59 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M786 84L787 85L786 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M57 85L58 86L57 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2ea",
      stroke: "none"
    },
    d: "M787 85L788 86L787 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M56 86L57 87L56 86M788 86L790 88L788 86M55 87L56 88L55 87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M788 87L789 88L788 87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M54 88L55 89L54 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M789 88L790 89L789 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M53 89L54 90L53 89M790 89L791 90L790 89M51.6667 90.3333L52.3333 90.6667L51.6667 90.3333M791 90L792 91L791 90M50 91L51 92L50 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M791 91L792 92L791 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M49.3333 92.6667L49.6667 93.3333L49.3333 92.6667M792 92L793 93L792 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M792 93L793 94L792 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M48 94L49 95L48 94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M793 94L794 95L793 94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M47 95L48 96L47 95M794 95L795 96L794 95M46 96L47 97L46 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M794 96L795 97L794 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M45 97L46 98L45 97M795 97L796 98L795 97M44.3333 98.6667L44.6667 99.3333L44.3333 98.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M795 98L796 99L795 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M796 99L797 100L796 99M43 100L44 101L43 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M796 100L797 101L796 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M42 101L43 102L42 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M656 101L655 105L656 105L656 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2ea",
      stroke: "none"
    },
    d: "M656 200C662.844 200 674.748 202.286 680.815 198.821C690.429 193.33 698.336 172.44 704 163C706.107 159.489 709.573 155.288 709.573 151C709.573 144.218 702.032 135.579 698.576 130C690.234 116.537 685.573 101.001 668 101C665.172 101 659.96 100.056 657.622 102.028C654.091 105.005 660.4 112.369 662.05 115C667.605 123.857 682.734 140.42 682.733 151C682.733 155.694 678.52 160.186 676.203 164C669.836 174.482 657.607 187.722 656 200z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M678 101L679 102L678 101M706 101L706 106L707 106L706 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2ea",
      stroke: "none"
    },
    d: "M706 200C712.715 200 723.921 202.147 729.96 198.972C740.248 193.563 747.999 172.688 754.05 163C756.385 159.262 760.072 154.69 759.62 150C758.91 142.632 751.144 134.205 747.399 128C739.427 114.79 735.038 101.001 718 101C715.217 101 709.925 100.042 707.647 102.028C704.293 104.951 710.443 112.433 712.05 115C717.609 123.882 732.886 140.375 732.886 151C732.886 155.616 728.743 160.276 726.424 164C719.934 174.42 707.612 187.689 706 200z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M728.667 101.333L729.333 101.667L728.667 101.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M797 101L798 102L797 101M41.3333 102.667L41.6667 103.333L41.3333 102.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M680 102L681 103L680 102M730 102L731 103L730 102M797 102L798 103L797 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M798 103L799 104L798 103M40 104L41 105L40 104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M798 104L799 105L798 104M683 105L684 106L683 105M733 105L734 106L733 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M799 105L800 106L799 105M39 106L40 107L39 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M656 106L657 107L656 106M799 106L800 107L799 106M657 107L658 108L657 107M684 107L685 108L684 107M707 107L708 108L707 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M800 107L801 108L800 107M38 108L39 109L38 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M685 108L686 109L685 108M735 108L736 109L735 108M800 108L801 109L800 108M658 109L659 110L658 109M708 109L709 110L708 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M801 109L802 110L801 109M37 110L38 111L37 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M659 110L660 111L659 110M686 110L687 111L686 110M709 110L710 111L709 110M736 110L737 111L736 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2ea",
      stroke: "none"
    },
    d: "M801 110L802 111L801 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M737 111L738 112L737 111M801 111L802 112L801 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M36.3333 112.667L36.6667 113.333L36.3333 112.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M660 112L661 113L660 112M687 112L688 113L687 112M710 112L711 113L710 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M802 112L803 113L802 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M688 113L689 114L688 113M738 113L739 114L738 113M802.333 113.667L802.667 114.333L802.333 113.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M35.3333 114.667L35.6667 115.333L35.3333 114.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M661 114L662 115L661 114M662 115L663 116L662 115M689 115L690 116L689 115M712 115L713 116L712 115M739 115L740 116L739 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M803 115L804 116L803 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M690 116L691 117L690 116M740 116L741 117L740 116M803 116L804 117L803 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M34.3333 117.667L34.6667 118.333L34.3333 117.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M663 117L664 118L663 117M713 117L714 118L713 117M664 118L665 119L664 118M691 118L692 119L691 118M714 118L715 119L714 118M741 118L742 119L741 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M804 118L805 119L804 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M804.333 119.667L804.667 120.333L804.333 119.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M33 120L33 123L34 123L33 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M665 120L666 121L665 120M692 120L693 121L692 120M715 120L716 121L715 120M742 120L743 121L742 120M693 121L694 122L693 121M743 121L744 122L743 121M666 122L667 123L666 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M805 122L806 123L805 122M32 123L32 127L33 127L32 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M667 123L668 124L667 123M694 123L695 124L694 123M717 123L718 124L717 123M744 123L745 124L744 123M805.333 123.667L805.667 124.333L805.333 123.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M126 125L126 126L130 126L126 125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6f7f7",
      stroke: "none"
    },
    d: "M153 164L144 163C141.693 172.126 132.39 180.139 124.533 170.892C117.459 162.567 116.704 135.956 131 133.761C142.147 132.049 140.757 147.907 153 145C150.636 129.228 132.917 118.793 119.04 129.558C111.329 135.54 108.672 146.656 109.04 156C109.386 164.781 112.374 175.166 120.004 180.297C133.712 189.516 151.62 179.707 153 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M134 125L134 126L138 126L134 125M241 125L241 126L245 126L241 125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6f7f7",
      stroke: "none"
    },
    d: "M268 164L259 163C258.166 165.406 257.34 167.797 255.867 169.907C250.725 177.275 242.6 176.3 237.995 168.995C232.45 160.201 232.354 135.788 246 133.762C256.744 132.166 255.681 147.924 268 145C264.436 129.6 247.233 117.736 233.043 130.225C224.866 137.422 223.066 149.695 224.174 160C227.038 186.661 263.645 193.054 268 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M249 125L249 126L253 126L249 125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M668 125L669 126L668 125M695 125L696 126L695 125M718 125L719 126L718 125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M123.667 126.333L124.333 126.667L123.667 126.333M139.667 126.333L140.333 126.667L139.667 126.333M161 126L161 183L162 183L162 144L161 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6f7f7",
      stroke: "none"
    },
    d: "M162 126L162 183C169.372 183 189.595 186.578 195.397 181.972C198.061 179.857 196.938 175.234 193.852 174.318C187.494 172.43 178.624 174 172 174L172 126L162 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M172 126L172 174L197 175C193.011 170.435 178.868 173 173 173C173 159.735 177.11 138.177 172 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6f7f7",
      stroke: "none"
    },
    d: "M204 126L204 183L214 183L214 126L204 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M214 126L214 183L215 183L215 144L214 126M238.667 126.333L239.333 126.667L238.667 126.333M254.667 126.333L255.333 126.667L254.667 126.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6f7f7",
      stroke: "none"
    },
    d: "M276 126L276 166L277.028 181.397L286 183C286 170.181 289.556 163.758 298 154C301.484 166.739 305.339 182.998 320 183L306.337 145L318 126C301.898 126.002 295.633 143.868 286 155L286 126L276 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M286 126L286 155L287 155L286 126M307 126L308 127L307 126M318 126L319 127L318 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6f7f7",
      stroke: "none"
    },
    d: "M350 126L350 183L360 183L360 158L382 158L382 183L392 183L392 126L382 126L382 150L360 150L360 126L350 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M360 126L360 150L382 150L382 149L361 149L360 126M392 126L392 183L393 183L393 144L392 126M404 126L404 183L405 183L405 144L404 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6f7f7",
      stroke: "none"
    },
    d: "M405 126L405 183L442 183L442 174L415 174L415 158L436 158L436 150L415 150L415 134L441 134L441 126L405 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M441 126L441 134C434.83 134 419.17 131.228 415 136L442 135L441 126M450 126L450 183L451 183L451 144L450 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6f7f7",
      stroke: "none"
    },
    d: "M451 126L451 183C465.047 182.989 461 170.002 461 159C464.795 159 470.399 157.994 473.775 160.028C479.165 163.275 482.401 177.152 484 183L494 183L485 157C496.608 153.042 498.854 135.596 487.985 129.086C478.023 123.119 462.153 126 451 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M481 126L481 127L484 127L481 126M505 126L505 183L506 183L506 144L505 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6f7f7",
      stroke: "none"
    },
    d: "M506 126L506 183L531 183C533.907 183 538.952 183.913 541.397 181.972C544.061 179.857 542.938 175.234 539.852 174.318C532.938 172.265 523.207 174 516 174L516 158L537 158L537 150L516 150L516 134L542 134L542 126L506 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M542 126L542 134L543 134L542 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M669 126L670 127L669 126M696 126L697 127L696 126M719 126L720 127L719 126M746 126L747 127L746 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M806 126L807 127L806 126M121 127L122 128L121 127M142 127L143 128L142 127M236 127L237 128L236 127M256.667 127.333L257.333 127.667L256.667 127.333M306 127L307 128L306 127M317 127L318 128L317 127M484.667 127.333L485.333 127.667L484.667 127.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2ea",
      stroke: "none"
    },
    d: "M806 127L807 128L806 127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M119.667 128.333L120.333 128.667L119.667 128.333M143.667 128.333L144.333 128.667L143.667 128.333M234 128L235 129L234 128M258 128L259 129L258 128M316.333 128.667L316.667 129.333L316.333 128.667M487 128L488 129L487 128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M670 128L671 129L670 128M697 128L698 129L697 128M720 128L721 129L720 128M747 128L748 129L747 128M806 128L807 129L806 128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M31 129L31 136L32 136L31 129M118 129L119 130L118 129M145 129L146 130L145 129M233 129L234 130L233 129M260 129L261 130L260 129M305 129L306 130L305 129M489 129L490 130L489 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M748 129L749 130L748 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M117 130L118 131L117 130M146 130L147 131L146 130M232 130L233 131L232 130M261 130L262 131L261 130M304 130L305 131L304 130M315 130L316 131L315 130M490 130L491 131L490 130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M671 130L672 131L671 130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M807.333 130.667L807.667 131.333L807.333 130.667M116 131L117 132L116 131M147 131L148 132L147 131M231 131L232 132L231 131M262 131L263 132L262 131M303.333 131.667L303.667 132.333L303.333 131.667M314 131L315 132L314 131M491 131L492 132L491 131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M672 131L673 132L672 131M699 131L700 132L699 131M722 131L723 132L722 131M749 131L750 132L749 131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M115 132L116 133L115 132M148 132L149 133L148 132M230 132L231 133L230 132M263.333 132.667L263.667 133.333L263.333 132.667M492 132L493 133L492 132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2ea",
      stroke: "none"
    },
    d: "M807 132L808 133L807 132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M114.333 133.667L114.667 134.333L114.333 133.667M130 133L130 134L134 134L130 133M229 133L230 134L229 133M245 133L245 134L249 134L245 133M302 133L303 134L302 133M313 133L314 134L313 133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M673 133L674 134L673 133M700 133L701 134L700 133M723 133L724 134L723 133M750 133L751 134L750 133M807.333 133.667L807.667 134.333L807.333 133.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M127.667 134.333L128.333 134.667L127.667 134.333M136 134L137 135L136 134M149 134L150 135L149 134M228.333 134.667L228.667 135.333L228.333 134.667M242 134L243 135L242 134M250.667 134.333L251.333 134.667L250.667 134.333M264 134L265 135L264 134M301 134L302 135L301 134M312 134L313 135L312 134M461 134L461 135L478 135L461 134M493 134L494 135L493 134M516 134L516 135L542 135L516 134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M701 134L702 135L701 134M724 134L725 135L724 134M751 134L752 135L751 134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M113 135L114 136L113 135M126 135L127 136L126 135M137 135L138 136L137 135M150.333 135.667L150.667 136.333L150.333 135.667M241 135L242 136L241 135M252 135L253 136L252 135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2ea",
      stroke: "none"
    },
    d: "M461 135C461 138.93 459.837 145.092 461.603 148.682C467.042 159.734 496.058 142.711 478.956 135.742C477.088 134.981 474.978 135.031 473 135.004C469.002 134.948 464.999 135 461 135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M479.667 135.333L480.333 135.667L479.667 135.333M125 136L126 137L125 136M139 136L140 137L139 136M227.333 136.667L227.667 137.333L227.333 136.667M253 136L254 137L253 136M265 136L266 137L265 136M300 136L301 137L300 136M311 136L312 137L311 136M481 136L482 137L481 136M494.333 136.667L494.667 137.333L494.333 136.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M675 136L676 137L675 136M702 136L703 137L702 136M725 136L726 137L725 136M752 136L753 137L752 136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M112 137L113 138L112 137M124 137L125 138L124 137M151.333 137.667L151.667 138.333L151.333 137.667M239 137L240 138L239 137M254 137L255 138L254 137M299 137L300 138L299 137M310 137L311 138L310 137M482 137L483 138L482 137M808.333 137.667L808.667 138.333L808.333 137.667M123 138L124 139L123 138M140 138L141 139L140 138M226.333 138.667L226.667 139.333L226.333 138.667M238 138L239 139L238 138M255 138L256 139L255 138M266.333 138.667L266.667 139.333L266.333 138.667M298 138L299 139L298 138M309 138L310 139L309 138M483.333 138.667L483.667 139.333L483.333 138.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M676 138L677 139L676 138M703 138L704 139L703 138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M111.333 139.667L111.667 140.333L111.333 139.667M141.333 139.667L141.667 140.333L141.333 139.667M237.333 139.667L237.667 140.333L237.333 139.667M297.333 139.667L297.667 140.333L297.333 139.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M677 139L678 140L677 139M704 139L705 140L704 139M727 139L728 140L727 139M754 139L755 140L754 139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2ea",
      stroke: "none"
    },
    d: "M808 139L809 140L808 139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M122 140L123 141L122 140M152.333 140.667L152.667 141.333L152.333 140.667M256 140L257 141L256 140M308 140L309 141L308 140M495 140L495 145L496 145L495 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M808 140L808 145L809 145L808 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M110.333 141.667L110.667 142.333L110.333 141.667M142.333 141.667L142.667 142.333L142.333 141.667M225.333 141.667L225.667 142.333L225.333 141.667M236.333 141.667L236.667 142.333L236.333 141.667M267.333 141.667L267.667 142.333L267.333 141.667M296 141L297 142L296 141M307 141L308 142L307 141M484 141L484 144L485 144L484 141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M678 141L679 142L678 141M705 141L706 142L705 141M728 141L729 142L728 141M755 141L756 142L755 141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M121.333 142.667L121.667 143.333L121.333 142.667M257.333 142.667L257.667 143.333L257.333 142.667M295 142L296 143L295 142M306.333 142.667L306.667 143.333L306.333 142.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M729 142L730 143L729 142M756 142L757 143L756 142M706 143L707 144L706 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M143.333 144.667L143.667 145.333L143.333 144.667M153 144L154 145L153 144M224 144L224 147L225 147L224 144M294 144L295 145L294 144M305.333 144.667L305.667 145.333L305.333 144.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M680 144L681 145L680 144M707 144L708 145L707 144M730 144L731 145L730 144M757 144L758 145L757 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M109 145L109 149L110 149L109 145M151.667 145.333L152.333 145.667L151.667 145.333M235 145L235 148L236 148L235 145M258 145L261 147L261 146L258 145M266.667 145.333L267.333 145.667L266.667 145.333M293 145L294 146L293 145M120 146L120 151L121 151L120 146M144 146L144 147L147 147L144 146M292 146L293 147L292 146M483 146L484 147L483 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M681 146L682 147L681 146M708 146L709 147L708 146M731 146L732 147L731 146M758 146L759 147L758 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M306 147L307 148L306 147M482 147L483 148L482 147M494.333 147.667L494.667 148.333L494.333 147.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M682.333 147.667L682.667 148.333L682.333 147.667M732 147L733 148L732 147M759 147L760 148L759 147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M291 148L292 149L291 148M481 148L482 149L481 148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M709 148L710 149L709 148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M290 149L291 150L290 149M307.333 149.667L307.667 150.333L307.333 149.667M415 149L416 150L415 149M480 149L481 150L480 149M289 150L290 151L289 150M436 150L436 158L437 158L436 150M461 150L462 151L461 150M477.667 150.333L478.333 150.667L477.667 150.333M493 150L494 151L493 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M733.333 150.667L733.667 151.333L733.333 150.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M223 151L223 158L224 158L223 151M308.333 151.667L308.667 152.333L308.333 151.667M288 152L289 153L288 152M492 152L493 153L492 152M491 153L492 154L491 153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M682.333 153.667L682.667 154.333L682.333 153.667M709 153L710 154L709 153M759.333 153.667L759.667 154.333L759.333 153.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M297 154L296 156L298 156L297 154M309.333 154.667L309.667 155.333L309.333 154.667M490 154L491 155L490 154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M732 154L733 155L732 154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M489 155L490 156L489 155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M681 155L682 156L681 155M708 155L709 156L708 155M731 155L732 156L731 155M758 155L759 156L758 155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M295 156L296 157L295 156M298.333 156.667L298.667 157.333L298.333 156.667M310.333 156.667L310.667 157.333L310.333 156.667M487.667 156.333L488.333 156.667L487.667 156.333M485 157L485 159L487 157L485 157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M680 157L681 158L680 157M707 157L708 158L707 157M730 157L731 158L730 157M757 157L758 158L757 157M808 157L808 161L809 161L808 157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M120 158L120 163L121 163L120 158M294 158L295 159L294 158M299.333 158.667L299.667 159.333L299.333 158.667M360 158L360 183L361 183L361 159L382 159L360 158M415 158L415 159L436 159L415 158M516 158L516 159L537 159L516 158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M706 158L707 159L706 158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M293 159L294 160L293 159M311 159L312 160L311 159M461 159L461 160L475 160L461 159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M729 159L730 160L729 159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M109 160L109 163L110 163L109 160M235 160L235 164L236 164L235 160M292 160L293 161L292 160M475 160L476 161L475 160M486.333 160.667L486.667 161.333L486.333 160.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M678 160L679 161L678 160M705 160L706 161L705 160M728 160L729 161L728 160M755 160L756 161L755 160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M300 161L301 162L300 161M312.333 161.667L312.667 162.333L312.333 161.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2ea",
      stroke: "none"
    },
    d: "M808 161L809 162L808 161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M224 162L224 165L225 165L224 162M291 162L292 163L291 162M476.333 162.667L476.667 163.333L476.333 162.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M704 162L705 163L704 162M727 162L728 163L727 162M754 162L755 163L754 162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M808 162L808 165L809 165L808 162M143 163L143 166L144 166L143 163M146 163L146 164L151 164L146 163M258.333 163.667L258.667 164.333L258.333 163.667M261 163L261 164L266 164L261 163M290 163L291 164L290 163M301.333 163.667L301.667 164.333L301.333 163.667M487.333 163.667L487.667 164.333L487.333 163.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M676 163L677 164L676 163M703 163L704 164L703 163M726 163L727 164L726 163M753 163L754 164L753 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M121 164L121 167L122 167L121 164M153.333 164.667L153.667 165.333L153.333 164.667M289 164L290 165L289 164M313 164L314 165L313 164M110 165L110 168L111 168L110 165M477.333 165.667L477.667 166.333L477.333 165.667M488.333 165.667L488.667 166.333L488.333 165.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M675 165L676 166L675 165M702 165L703 166L702 165M725 165L726 166L725 165M752 165L753 166L752 165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M225.333 166.667L225.667 167.333L225.333 166.667M236 166L237 167L236 166M288 166L289 167L288 166M302 166L303 167L302 166M314.333 166.667L314.667 167.333L314.333 166.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M674 166L675 167L674 166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M31 167L31 173L32 173L31 167M122.333 167.667L122.667 168.333L122.333 167.667M142.333 167.667L142.667 168.333L142.333 167.667M257 167L258 168L257 167M267.333 167.667L267.667 168.333L267.333 167.667M287 167L288 168L287 167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M701 167L702 168L701 167M724 167L725 168L724 167M751 167L752 168L751 167M807.333 167.667L807.667 168.333L807.333 167.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M111.333 168.667L111.667 169.333L111.333 168.667M152.333 168.667L152.667 169.333L152.333 168.667M237 168L238 169L237 168M286 168L286 183L287 183L286 168M303 168L304 169L303 168M315.333 168.667L315.667 169.333L315.333 168.667M478 168L479 169L478 168M489.333 168.667L489.667 169.333L489.333 168.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M673 168L674 169L673 168M700 168L701 169L700 168M723 168L724 169L723 168M750 168L751 169L750 168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M123 169L124 170L123 169M141 169L142 170L141 169M226.333 169.667L226.667 170.333L226.333 169.667M256 169L257 170L256 169z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2ea",
      stroke: "none"
    },
    d: "M807 169L808 170L807 169z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M238 170L239 171L238 170M255 170L256 171L255 170M266.333 170.667L266.667 171.333L266.333 170.667M304.333 170.667L304.667 171.333L304.333 170.667M479.333 170.667L479.667 171.333L479.333 170.667M490.333 170.667L490.667 171.333L490.333 170.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M672 170L673 171L672 170M699 170L700 171L699 170M722 170L723 171L722 170M749 170L750 171L749 170z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M807 170L808 171L807 170M112 171L113 172L112 171M124 171L125 172L124 171M140 171L141 172L140 171M151 171L152 172L151 171M227.333 171.667L227.667 172.333L227.333 171.667M239 171L240 172L239 171M316.333 171.667L316.667 172.333L316.333 171.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M671 171L672 172L671 171M721 171L722 172L721 171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M125 172L126 173L125 172M139 172L140 173L139 172M240 172L241 173L240 172M254 172L255 173L254 172M265.333 172.667L265.667 173.333L265.333 172.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M806.333 172.667L806.667 173.333L806.333 172.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M113 173L114 174L113 173M126 173L127 174L126 173M138 173L139 174L138 173M150 173L151 174L150 173M228.333 173.667L228.667 174.333L228.333 173.667M241 173L242 174L241 173M252 173L253 174L252 173M305 173L306 174L305 173M317.333 173.667L317.667 174.333L317.333 173.667M415 173L416 174L415 173M480.333 173.667L480.667 174.333L480.333 173.667M491.333 173.667L491.667 174.333L491.333 173.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M670 173L671 174L670 173M697 173L698 174L697 173M720 173L721 174L720 173M747 173L748 174L747 173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M128 174L129 175L128 174M136 174L137 175L136 174M242.667 174.333L243.333 174.667L242.667 174.333M250.667 174.333L251.333 174.667L250.667 174.333M264 174L265 175L264 174M542 174L543 175L542 174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M669 174L670 175L669 174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2ea",
      stroke: "none"
    },
    d: "M806 174L807 175L806 174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M32 175L32 179L33 179L32 175M114 175L115 176L114 175M131 175L131 176L134 176L131 175M149 175L150 176L149 175M229 175L230 176L229 175M245 175L245 176L249 176L245 175M306.333 175.667L306.667 176.333L306.333 175.667M481.333 175.667L481.667 176.333L481.333 175.667M492.333 175.667L492.667 176.333L492.333 175.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M696 175L697 176L696 175M719 175L720 176L719 175M746 175L747 176L746 175z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M806 175L807 176L806 175M115 176L116 177L115 176M148 176L149 177L148 176M230 176L231 177L230 176M263 176L264 177L263 176M318 176L319 177L318 176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M668 176L669 177L668 176M695 176L696 177L695 176M718 176L719 177L718 176M745 176L746 177L745 176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M116 177L117 178L116 177M147 177L148 178L147 177M231 177L232 178L231 177M262 177L263 178L262 177z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M805 177L806 178L805 177z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M117 178L118 179L117 178M146 178L147 179L146 178M232 178L233 179L232 178M261 178L262 179L261 178M307 178L308 179L307 178M319.333 178.667L319.667 179.333L319.333 178.667M482.333 178.667L482.667 179.333L482.333 178.667M493.333 178.667L493.667 179.333L493.333 178.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M667 178L668 179L667 178M694 178L695 179L694 178M717 178L718 179L717 178M744 178L745 179L744 178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2ea",
      stroke: "none"
    },
    d: "M805 178L806 179L805 178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M118 179L119 180L118 179M145 179L146 180L145 179M233 179L234 180L233 179M260 179L261 180L260 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M666 179L667 180L666 179M716 179L717 180L716 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M805 179L806 180L805 179M33.3333 180.667L33.6667 181.333L33.3333 180.667M119 180L120 181L119 180M144 180L145 181L144 180M234 180L235 181L234 180M258 180L259 181L258 180M308.333 180.667L308.667 181.333L308.333 180.667M483.333 180.667L483.667 181.333L483.333 180.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M693 180L694 181L693 180M743 180L744 181L743 180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M121 181L122 182L121 181M142 181L143 182L142 181M235.667 181.333L236.333 181.667L235.667 181.333M256.667 181.333L257.333 181.667L256.667 181.333M320.333 181.667L320.667 182.333L320.333 181.667M494.333 181.667L494.667 182.333L494.333 181.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M665 181L666 182L665 181M692 181L693 182L692 181M715 181L716 182L715 181M742 181L743 182L742 181M804 181L805 182L804 181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M123.667 182.333L124.333 182.667L123.667 182.333M139.667 182.333L140.333 182.667L139.667 182.333M196 182L197 183L196 182M237.667 182.333L238.333 182.667L237.667 182.333M254.667 182.333L255.333 182.667L254.667 182.333M276 182L277 183L276 182M309 182L310 183L309 182M460 182L461 183L460 182M542 182L543 183L542 182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M664 182L665 183L664 182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M804.333 182.667L804.667 183.333L804.333 182.667M34.3333 183.667L34.6667 184.333L34.3333 183.667M126 183L126 184L129 184L126 183M134 183L134 184L138 184L134 183M241 183L241 184L244 184L241 183M249 183L249 184L253 184L249 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M691 183L692 184L691 183M741 183L742 184L741 183M663 184L664 185L663 184M713 184L714 185L713 184M803 184L804 185L803 184M690 185L691 186L690 185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2ea",
      stroke: "none"
    },
    d: "M803 185L804 186L803 185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M35.3333 186.667L35.6667 187.333L35.3333 186.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M662 186L663 187L662 186M689 186L690 187L689 186M712 186L713 187L712 186M739 186L740 187L739 186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M803 186L804 187L803 186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M661 187L662 188L661 187M711 187L712 188L711 187M802 187L803 188L802 187M688 188L689 189L688 188M738 188L739 189L738 188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M802.333 188.667L802.667 189.333L802.333 188.667M36 189L37 190L36 189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M660 189L661 190L660 189M710 189L711 190L710 189M737 189L738 190L737 189M659 190L660 191L659 190M801 190L802 191L801 190z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M37 191L38 192L37 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M686 191L687 192L686 191M736 191L737 192L736 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M801 191L802 192L801 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M658 192L659 193L658 192M708 192L709 193L708 192M800 192L801 193L800 192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M38 193L39 194L38 193z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M685 193L686 194L685 193M735 193L736 194L735 193z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2ea",
      stroke: "none"
    },
    d: "M800 193L801 194L800 193z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M657 194L658 195L657 194M707 194L708 195L707 194M734 194L735 195L734 194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M800 194L801 195L800 194M39 195L40 196L39 195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M656 195L657 196L656 195M706 195L707 196L706 195M799 195L800 196L799 195M683 196L684 197L683 196M733 196L734 197L733 196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M799 196L800 197L799 196M40 197L41 198L40 197z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M655 197L655 200L656 200L655 197M705 197L705 200L706 200L705 197M732 197L733 198L732 197M798 197L799 198L798 197z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M41.3333 198.667L41.6667 199.333L41.3333 198.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M731 198L732 199L731 198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M798 198L799 199L798 198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M680 199L681 200L680 199M730 199L731 200L730 199M797 199L798 200L797 199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M42 200L43 201L42 200z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M656 200L656 201L679 201L656 200M706 200L706 201L729 201L706 200z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M797 200L798 201L797 200M43 201L44 202L43 201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M796 201L797 202L796 201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M796 202L797 203L796 202M44 203L45 204L44 203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M795 203L796 204L795 203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M45 204L46 205L45 204M795 204L796 205L795 204M46 205L47 206L46 205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M794 205L793 207L794 205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M47 206L48 207L47 206M794 206L795 207L794 206M48 207L49 208L48 207M793 207L794 208L793 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M792 208L793 209L792 208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M49 209L50 210L49 209M792 209L793 210L792 209M50 210L51 211L50 210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2ea",
      stroke: "none"
    },
    d: "M791 210L792 211L791 210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M51 211L52 212L51 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M790 211L791 212L790 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M53 212L54 213L53 212M790 212L791 213L790 212M54 213L55 214L54 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2ea",
      stroke: "none"
    },
    d: "M789 213L790 214L789 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M55 214L56 215L55 214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M788 214L789 215L788 214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M56 215L57 216L56 215M788 215L789 216L788 215M57 216L58 217L57 216M787 216L788 217L787 216M59 217L60 218L59 217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M786 217L787 218L786 217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M60 218L61 219L60 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M785 218L784 220L785 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M61.6667 219.333L62.3333 219.667L61.6667 219.333M785 219L786 220L785 219M63 220L64 221L63 220M784 220L785 221L784 220M65 221L66 222L65 221M783 221L784 222L783 221M67 222L68 223L67 222M782 222L783 223L782 222M69 223L70 224L69 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M781 223L782 224L781 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M71 224L72 225L71 224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M780 224L781 225L780 224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M73.6667 225.333L74.3333 225.667L73.6667 225.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M779 225L774 231L779 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M76.6667 226.333L77.3333 226.667L76.6667 226.333M779 226L780 227L779 226M79.6667 227.333L80.3333 227.667L79.6667 227.333M778 227L779 228L778 227M82 228L82 229L85 229L82 228M777 228L778 229L777 228M87 229L87 230L92 230L87 229M776 229L777 230L776 229M98.6667 230.333L99.3333 230.667L98.6667 230.333M120 230L120 231L140 231L120 230M160 230L160 231L180 231L160 230M200 230L200 231L220 231L200 230M240 230L240 231L260 231L240 230M280 230L280 231L300 231L280 230M320 230L320 231L340 231L320 230M360 230L360 231L380 231L360 230M400 230L400 231L420 231L400 230M440 230L440 231L460 231L440 230M480 230L480 231L500 231L480 230M520 230L520 231L540 231L520 230M560 230L560 231L580 231L560 230M600 230L600 231L624 231L600 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M624 230L625 231L624 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M775 230L776 231L775 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M625 231L626 232L625 231M773 231L774 232L773 231M626 232L627 233L626 232M772 232L773 233L772 232M627 233L628 234L627 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2ea",
      stroke: "none"
    },
    d: "M771 233L772 234L771 233M628 234L629 235L628 234M770 234L771 235L770 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M629 235L630 236L629 235M769 235L770 236L769 235M630 236L631 237L630 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M631 236L632 237L631 236M767 236L768 237L767 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M768 236L769 237L768 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M632 237L633 238L632 237M766 237L767 238L766 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2ea",
      stroke: "none"
    },
    d: "M633 238L634 239L633 238M765 238L766 239L765 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M634 239L635 240L634 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M763 239L764 240L763 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M764 239L765 240L764 239M635 240L636 241L635 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M636 240L637 241L636 240M762 240L763 241L762 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2ea",
      stroke: "none"
    },
    d: "M637 241L638 242L637 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M760 241L761 242L760 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M761 241L762 242L761 241M638 242L639 243L638 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M639 242L640 243L639 242M759 242L760 243L759 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M640 243L641 244L640 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M757 243L758 244L757 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M758 243L759 244L758 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M642 244L643 245L642 244M756 244L757 245L756 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M643 245L644 246L643 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M644 245L645 246L644 245M754 245L755 246L754 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M755 245L756 246L755 245M645 246L646 247L645 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M646 246L647 247L646 246M752 246L753 247L752 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M753 246L754 247L753 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2ea",
      stroke: "none"
    },
    d: "M647 247L648 248L647 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M750 247L751 248L750 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2ea",
      stroke: "none"
    },
    d: "M751 247L752 248L751 247M649 248L650 249L649 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M748 248L749 249L748 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M749 248L750 249L749 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2ea",
      stroke: "none"
    },
    d: "M651 249L652 250L651 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M746 249L747 250L746 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2ea",
      stroke: "none"
    },
    d: "M747 249L748 250L747 249M653 250L654 251L653 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M654 250L655 251L654 250M744 250L745 251L744 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M745 250L746 251L745 250M655 251L656 252L655 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M656 251L657 252L656 251M742 251L743 252L742 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M743 251L744 252L743 251M657 252L658 253L657 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M658 252L659 253L658 252M740 252L741 253L740 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M741 252L742 253L741 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2ea",
      stroke: "none"
    },
    d: "M660 253L661 254L660 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M661 253L662 254L661 253M737 253L738 254L737 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M738 253L739 254L738 253M662 254L663 255L662 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2ea",
      stroke: "none"
    },
    d: "M663 254L664 255L663 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M664 254L665 255L664 254M734 254L735 255L734 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M735 254L736 255L735 254M665 255L666 256L665 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2ea",
      stroke: "none"
    },
    d: "M666 255L667 256L666 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M667 255L668 256L667 255M731 255L732 256L731 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M732.667 255.333L733.333 255.667L732.667 255.333M668.667 256.333L669.333 256.667L668.667 256.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M670.667 256.333L671.333 256.667L670.667 256.333M727.667 256.333L728.333 256.667L727.667 256.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M729 256L730 257L729 256M672 257L673 258L672 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2ea",
      stroke: "none"
    },
    d: "M673 257L674 258L673 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M674 257L675 258L674 257M723.667 257.333L724.333 257.667L723.667 257.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M725.667 257.333L726.333 257.667L725.667 257.333M676.667 258.333L677.333 258.667L676.667 258.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M678 258L678 259L681 259L678 258M718.667 258.333L719.333 258.667L718.667 258.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2ea",
      stroke: "none"
    },
    d: "M720 258L721 259L720 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M721 258L722 259L721 258M682.667 259.333L683.333 259.667L682.667 259.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2ea",
      stroke: "none"
    },
    d: "M684 259L685 260L684 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M685 259L685 260L688 260L685 259M711 259L711 260L714 260L711 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2ea",
      stroke: "none"
    },
    d: "M714 259L715 260L714 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M715.667 259.333L716.333 259.667L715.667 259.333M690 260L690 261L695 261L690 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d91ac",
      stroke: "none"
    },
    d: "M695 260L695 261L700 261L695 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2ea",
      stroke: "none"
    },
    d: "M700 260L700 261L703 261L700 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ed3e9",
      stroke: "none"
    },
    d: "M703 260L703 261L708 261L703 260z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClickHere);
export default __webpack_public_path__ + "static/media/click_here.844ccd99b4c510480e285595477a979f.svg";
export { ForwardRef as ReactComponent };